import { RobotTextResources } from "@portal/assets/text/RobotTextResources";

import { RiskLevel } from "@portal/types/robot/IRobotEnums";
import Typography from "@portal/components/atoms/v2/typography";
import { AgreementDetailsChart } from "./AgreementDetailsChart";
import { expectedYield, optimisticYield, pessimisticYield } from "./AgreementDetailsData";

interface Props {
  riskLevel: RiskLevel;
  isDefaultLanguage: boolean;
}

export const AgreementGraph = ({ riskLevel, isDefaultLanguage }: Props) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  return (
    <div className="mt-5 space-y-3">
      <Typography variant="Lead">{texts.PAGE_13_SAVINGS_RESULT_TITLE}</Typography>
      <div className="flex flex-col my-1 py-4 border dark:border-blueBorderDark rounded-md w-full p-1 bg-pageBoxBackgroundLight dark:bg-pageBoxBackgroundDark h-[400px] ">
        <AgreementDetailsChart riskLevel={riskLevel ?? RiskLevel.Unknown} />
      </div>
      <Typography variant="Body">
        {`${texts.PAGE_13_SAVINGS_RESULT.replace("$EXPECTED_YIELD", expectedYield(riskLevel).toString())
          .replace("$PESSIMISTIC_YIELD", pessimisticYield(riskLevel).toString())
          .replace("$OPTIMISTIC_YIELD", optimisticYield(riskLevel).toString())}`}
      </Typography>
    </div>
  );
};
